import { useState, useRef } from 'react';
import { Common } from '@stockbit/ui';
import { Container, NextButton, PrevButton, Slider } from './styled';
import SuggestedItem from './SuggestedItem';

import Loading from './Loading';
import useSuggestedPeopleWidget from './Hooks/useSuggestedPeopleWidget';
import { SWIPER_PARAMS } from './constants';
import {
  DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_CONTAINER,
  DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_NAVIGATION_NEXT,
  DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_NAVIGATION_PREV,
} from './__tests__/constant';
import { Suggestions } from '../../../@types/friend';

const { Iconmoon } = Common;

function SwiperContainer(): JSX.Element {
  const [isNavVisible, setVisibleNav] = useState<boolean>(false);

  const swiperRef = useRef(null);

  const { isFetching, data } = useSuggestedPeopleWidget();

  const goNext = () => {
    swiperRef.current.slickNext();
  };

  const goPrev = () => {
    swiperRef.current.slickPrev();
  };

  const loadingData = new Array(4).fill(null).map((_, i) => ({ id: i }));

  return (
    <Container
      data-cy={DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_CONTAINER}
      onMouseEnter={() => setVisibleNav(true)}
      onMouseLeave={() => setVisibleNav(false)}
    >
      <Slider
        ref={(slider) => {
          swiperRef.current = slider;
        }}
        nextArrow={
          <NextButton
            isVisible={isNavVisible}
            onClick={goNext}
            data-cy={
              DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_NAVIGATION_NEXT
            }
          >
            <Iconmoon className="icon-toolbar_next" />
          </NextButton>
        }
        prevArrow={
          <PrevButton
            isVisible={isNavVisible}
            onClick={goPrev}
            data-cy={
              DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_SWIPER_NAVIGATION_PREV
            }
          >
            <Iconmoon className="icon-toolbar_prev" />
          </PrevButton>
        }
        {...SWIPER_PARAMS}
      >
        {isFetching && loadingData.map((arr) => <Loading key={arr.id} />)}
        {!isFetching &&
          data &&
          data.map((people: Suggestions, index: number) => (
            <SuggestedItem
              key={people.user.userid}
              user={people.user}
              isFollowed={people.user.follow}
              reason={people.reason}
              index={index}
            />
          ))}
      </Slider>
    </Container>
  );
}

export default SwiperContainer;
